
import { Button, Divider } from "antd";
import { produce } from "immer";
import { firstLetterCaps, generateUUID } from "../../../helpers/helper";
import Title from "antd/es/typography/Title";
import { Field } from "./BuildConfigRenderer";
import ExtraOptions from "../../atoms/ExtraOptions";
import React,{ useState,useRef, useEffect } from "react";
import { keys, size } from "lodash";
import {CloseCircleOutlined} from "@ant-design/icons"
import invoiceConfig from './configs.json'
import { getIcon } from "../../atoms/FuzzyIcon";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
const BuildCard = ({ path, values, cardSchema, actions }) => {
  // console.log(cardSchema,values)
  const deletePath = () =>{


    const [repeaterKey , groupId , idx , index] = path
    if (typeof idx === "string"){
      actions.deleteFromGroup(repeaterKey , groupId , values['id'])
    } else {
      actions.deleteRepeater(repeaterKey , values['id'])
    }

  }
  return (
    <div className="text-sm
        relative border border-gray-200 rounded-lg p-2 mb-3
        shadow-sm hover:shadow-md transition-all duration-200

      ">
        <CloseCircleOutlined className="
          absolute top-[-1px] right-[-1px] text-gray-400 hover:text-red-500
          transition-colors duration-150
        " onClick={deletePath}/>
      {cardSchema.map((item) => (
        <Field
          key={values['id']+ '-'+item.dataField}
          fieldInfo={item}
          onChange={(value) =>
            actions.updateFieldPath([...path, item.dataField], value)
          }
          value={values[item.dataField] ?? ""}
        />
      ))}
    </div>
  );
};
const BuildGroup = ({ repeaterKey, groupId, groupData, actions , groupSchema , defaultGroupIds}) => {

  const editableTemp = useRef("");
  const heading = groupData?.name
  const headers = (
    <div className="flex gap-4">
      <Title
        editable={
          defaultGroupIds[repeaterKey] === groupId
            ? false
            : {
                onEnd: () =>
                  actions.updateFieldPath(
                    [repeaterKey, groupId, "name"],
                    editableTemp.current
                  ),
                onChange: (_) => (editableTemp.current = _),
              }
        }
        key={`title-${groupId}`}
        level={5}
        className="w-[60%] p-1"
      >
        {groupData?.name}
      </Title>
      <ExtraOptions
        keyPrefix={heading}
        options={{
          Add: { onClick: () => actions.addToGroup(repeaterKey, groupId) },
          Delete: { onClick: () => actions.deleteGroup(repeaterKey, groupId), withPrompt: true },
        }}
        className="w-[40%]"
      />
    </div>
  );

  return (
    <>
      {headers}
      {Array.isArray(groupData?.items) &&
        groupData.items.map((item, index) => (
          <BuildCard
          path={[repeaterKey , groupId , 'items', index]}
            key={item.id }
            cardSchema={groupSchema}
            values={item}
            actions={actions}
          />
        ))}
    </>
  );
};

const BuildGroups = ({
  repeaterKey,
  groupsData = {},
  groupSchema,
  actions,
  addOptions,
  defaultGroupIds
}) => {

  return (
    <>
      {Object.keys(groupsData || {}).map((groupId) => (
        <BuildGroup
          key={[repeaterKey,groupId].join('-')}
          repeaterKey={repeaterKey}
          groupId={groupId}
          groupData={groupsData[groupId]}
          groupSchema={groupSchema}
          actions={actions}
          defaultGroupIds={defaultGroupIds}
        />
      ))}

      {addOptions?.map((item) => (
        <Button type="primary" size="small"
            className="ml-1" key={[repeaterKey,item.value.toLowerCase()].join('-')} onClick={() => actions.addGroup(repeaterKey , item.value.toLowerCase() === 'default' )}>{item.label}</Button>
      ))}
    </>
  );
};
const BuildRepeater = ({
  repeaterKey,
  repeaterData,
  repeaterSchema,
  actions,
}) => {
  return (
    <>
      {repeaterData &&
        repeaterData.map((item ,idx) => (
          <BuildCard key={[item['id']].join('-')} path={[repeaterKey,idx]} values={item} cardSchema={repeaterSchema} actions={actions} />
        ))}
      <Button type="primary" size="small"
            className="ml-1" onClick={() => actions.addRepeater(repeaterKey)}>
        {"Add " + repeaterKey}
      </Button>
    </>
  );
};
const BuilderTools = ({ loadedConfig , setPreviewData , values , setValue , config }) => {
  let [formData, setFormData] = useState(loadedConfig || {});
  const [configs,setConfigs] = useState(invoiceConfig)
  const [activeKeys, setActiveKeys] = useState([]);

 // your helper
  const [defaultGroupIds , setDefaultGroupIds] = useState({})
const actions = {
  addGroup: (repeaterKey , isDefault=false) => {
    const groupId = generateUUID();
  const updatedState = produce(formData, (draft) => {
    // ✅ ensure the key exists and is an object (for grouped repeaters)
    if (!draft[repeaterKey]) draft[repeaterKey] = {};

    var groupName = groupId
    // ✅ create a new group id
    if (isDefault){
      groupName = "Default"
    }
      if(isDefault && defaultGroupIds[repeaterKey]){
        draft[repeaterKey][defaultGroupIds[repeaterKey]]['items'].push({
          id: generateUUID(),
          name: "",
          value: "",
        })

      } else {



    // ✅ create new group structure
    draft[repeaterKey][groupId] = {
      id: groupId,
      name: groupName ,
      items: [
        {
          id: generateUUID(),
          name: "",
          value: "",
        },
      ],
    }

  }
  });

  // ✅ apply updated immutable state
  setFormData(updatedState);
  if( isDefault && !defaultGroupIds[repeaterKey])
  setDefaultGroupIds({...defaultGroupIds , [repeaterKey]:groupId})
}
,

  deleteGroup: (repeaterKey, groupId) => {
    const updatedState = produce(formData, (draft) => {
      if (draft[repeaterKey] && draft[repeaterKey][groupId]) {
        delete draft[repeaterKey][groupId];
      } else {
        console.warn("deleteGroup: missing path", { repeaterKey, groupId });
      }
    });
    setFormData(updatedState);
  },

  addToGroup: (repeaterKey, groupId) => {
    const updatedState = produce(formData, (draft) => {
      if (!draft[repeaterKey] || !draft[repeaterKey][groupId]) {
        // create group if missing (defensive)
        if (!draft[repeaterKey]) draft[repeaterKey] = {};
        draft[repeaterKey][groupId] = { id: groupId, name: "", items: [] };
      }

      if (!Array.isArray(draft[repeaterKey][groupId].items)) {
        draft[repeaterKey][groupId].items = [];
      }

      draft[repeaterKey][groupId].items.push({
        id: generateUUID(),
        name: "",
        value: "",
      });
    });
    setFormData(updatedState);
  },

  deleteFromGroup: (repeaterKey, groupId, id) => {
    const updatedState = produce(formData, (draft) => {
      const group = draft[repeaterKey] && draft[repeaterKey][groupId];
      if (group && Array.isArray(group.items)) {
        // assign filtered result back
        group.items = group.items.filter((item) => item.id !== id);
      } else {
        console.warn("deleteFromGroup: missing group or items", { repeaterKey, groupId, id });
      }
    });
    setFormData(updatedState);
  },

  // treats repeaterKey as array of items (separate from groups above)
  addRepeater: (repeaterKey) => {
    const updatedState = produce(formData, (draft) => {
      if (!Array.isArray(draft[repeaterKey])) draft[repeaterKey] = [];
      draft[repeaterKey].push({ id: generateUUID(), name: "", value: "" });
    });
    setFormData(updatedState);
  },

  deleteRepeater: (repeaterKey, id) => {
    const updatedState = produce(formData, (draft) => {
      if (Array.isArray(draft[repeaterKey])) {
        draft[repeaterKey] = draft[repeaterKey].filter((item) => item.id !== id);
      } else {
        console.warn("deleteRepeater: missing or non-array", { repeaterKey, id });
      }
    });
    setFormData(updatedState);
  },

  // path is array of keys (strings or numeric indices)
  updateFieldPath: (path, value) => {
    if (!Array.isArray(path) || path.length === 0) {
      console.warn("updateFieldPath: invalid path", path);
      return;
    }

    const updatedState = produce(formData, (draft) => {
      // walk to the parent of the target
      let cursor = draft;
      for (let i = 0; i < path.length - 1; i++) {
        const p = path[i];
        // create intermediate objects/arrays if missing
        if (cursor[p] === undefined) {
          // decide: if next key is a numeric index treat as array, else object
          const nextKey = path[i + 1];
          cursor[p] = typeof nextKey === "number" ? [] : {};
        }
        cursor = cursor[p];
      }
      const lastKey = path[path.length - 1];
      cursor[lastKey] = value;
    });

    setFormData(updatedState);
  },
};

useEffect(() => {
  if (values) {
    setFormData(values);
  } else {
    setFormData(loadedConfig || {});
  }
}, [values, loadedConfig]);
   useEffect(()=>{
    if(!values)
    setPreviewData(formData)
  },[formData])
  useEffect(()=>{
    if(config)
    setConfigs(config)
  else
    setConfigs(invoiceConfig)
  },[config])



useEffect(() => {
  const sectionKeys = Object.keys(configs || {});
  if (sectionKeys.length) {
    setActiveKeys(sectionKeys.slice(0, 2));
  }
}, [configs]);
  return (
    <div >


<Collapse
  bordered={false}
activeKey={activeKeys}
  onChange={setActiveKeys}
  expandIcon={({ isActive }) => (
    <CaretRightOutlined
      rotate={isActive ? 90 : 0}
      style={{ fontSize: 14, color: "#667085" }}
    />
  )}
  style={{ background: "transparent" }}

>
  {Object.keys(configs || {}).map((section, idx) => {
    return (
      <Collapse.Panel
        key={section}
        style={{
          marginBottom: 12,
          borderRadius: 12,
          background: "#fff",
          border: "1px solid #f0f0f0",
          overflow: "hidden",
        }}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: 500,
              fontSize: 16,
            }}
          >
            {getIcon(section, true, { size: 22 })}
            <span>{firstLetterCaps(section)}</span>
          </div>
        }
      >
        <div style={{ padding: "8px 4px" }}>
          <div className="mb-3" key={"wrapper" + section}>


            {configs[section].map((item) => {
              if (item.type.startsWith("repeaterGroup")) {
                return (
                  <BuildGroups
                    key={item.type.split(":").pop()}
                    actions={actions}
                    repeaterKey={item.type.split(":").pop()}
                    groupsData={formData[item.type.split(":").pop()] ?? {}}
                    groupSchema={item.itemSchema}
                    addOptions={item.addOptions}
                    defaultGroupIds={defaultGroupIds}
                  />
                );
              }

              if (item.type.startsWith("repeater")) {
                return (
                  <BuildRepeater
                    key={item.type.split(":").pop()}
                    actions={actions}
                    repeaterSchema={item.itemSchema}
                    repeaterKey={item.type.split(":").pop()}
                    repeaterData={formData[item.type.split(":").pop()]}
                  />
                );
              }

              return (
                <Field
                  key={"plain-" + item.dataField + item.type}
                  fieldInfo={{ ...item }}
                  onChange={(value) => {
                    if (setValue) {
                      setValue(item.dataField, value);
                      return;
                    }
                    actions.updateFieldPath([item.dataField], value);
                  }}
                  value={formData?.[item.dataField] ?? ""}
                />
              );
            })}
          </div>
        </div>
      </Collapse.Panel>
    );
  })}
</Collapse>
    </div>
  );
};

export default BuilderTools;
